import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  .add-doc{
  align-self: flex-end;
  width: fit-content;
  margin-bottom: 10px;

  }
`;
